import gql from 'graphql-tag';

const createMarketFactorMutation = gql`
  mutation createMarketFactor($input: CreateMarketFactorInput!) {
    createMarketFactor(input: $input) {
      success
      errors
    }
  }
`;

export default createMarketFactorMutation;
